import { merge } from "merge-anything";

import {
  commonBlocksOptions,
  defaultBlockSettings,
  specificBlockOptions,
} from "@components/cmsBlocks/configs";
// import {
//   initBlockData as initNewContentData,
//   initEmptyBlockData as initEmptyNewContentData,
// } from "./NewContentBlock/datas";
// import NewContentBlock from "./NewContentBlock/NewContentBlock";
import allDestinationsSvg from "@images/svg/CMS/all-destinations.svg";
import allRoutesSvg from "@images/svg/CMS/all-routes.svg";
import contactsSvg from "@images/svg/CMS/contact.svg";
import contentSvg from "@images/svg/CMS/content.svg";
import destinationsSvg from "@images/svg/CMS/destinations.svg";
import galleryAndTextSvg from "@images/svg/CMS/gallery-and-text.svg";
import gallerySvg from "@images/svg/CMS/gallery.svg";
import heroSvg from "@images/svg/CMS/hero.svg";
import lastSvg from "@images/svg/CMS/last.svg";
import latestHeroSvg from "@images/svg/CMS/latest-hero.svg";
import latestSvg from "@images/svg/CMS/latest.svg";
import newsSvg from "@images/svg/CMS/news.svg";
import popularSvg from "@images/svg/CMS/popular.svg";
import promoSvg from "@images/svg/CMS/promo.svg";
import stopsSvg from "@images/svg/CMS/stops.svg";
import testimonialsSvg from "@images/svg/CMS/testimonials.svg";
import whyLuxSvg from "@images/svg/CMS/why-lux.svg";

import AdvBannerBlock from "./AdvBannerBlock/AdvBannerBlock";
import {
  initBlockData as initAdvBannerData,
  initEmptyBlockData as initEmptyAdvBannerData,
} from "./AdvBannerBlock/datas";
import AllDestinationsBlock from "./AllDestinationsBlock/AllDestinationsBlock";
import {
  initBlockData as initAllDestinationsData,
  initEmptyBlockData as initEmptyAllDestinationsData,
} from "./AllDestinationsBlock/datas";
import AllRoutesBlock from "./AllRoutesBlock/AllRoutesBlock";
import {
  initBlockData as initAllRoutesData,
  initEmptyBlockData as initEmptyAllRoutesData,
} from "./AllRoutesBlock/datas";
import BannerBlock from "./BannerBlock/BannerBlock";
import {
  initBlockData as initBannerData,
  initEmptyBlockData as initEmptyBannerData,
} from "./BannerBlock/datas";
import { CONTENT } from "./blocks";
import ButtonBlock from "./ButtonBlock/ButtonBlock";
import {
  initBlockData as initButtonData,
  initEmptyBlockData as initEmptyButtonData,
} from "./ButtonBlock/datas";
import ContactsBlock from "./ContactsBlock/ContactsBlock";
import {
  initBlockData as initContactsData,
  initEmptyBlockData as initEmptyContactsData,
} from "./ContactsBlock/datas";
import ContentBlock from "./ContentBlock/ContentBlock";
import {
  initBlockData as initContentData,
  initEmptyBlockData as initEmptyContentData,
} from "./ContentBlock/datas";
import {
  initBlockData as initGaleryV1Data,
  initEmptyBlockData as initEmptyGaleryV1Data,
} from "./GaleryV1Block/datas";
import GaleryV1Block from "./GaleryV1Block/GaleryV1Block";
import {
  initBlockData as initGaleryV2Data,
  initEmptyBlockData as initEmptyGaleryV2Data,
} from "./GaleryV2Block/datas";
import GaleryV2Block from "./GaleryV2Block/GaleryV2Block";
import {
  initBlockData as initGaleryV3Data,
  initEmptyBlockData as initEmptyGaleryV3Data,
} from "./GaleryV3Block/datas";
import GaleryV3Block from "./GaleryV3Block/GaleryV3Block";
import {
  initBlockData as initGaleryV4Data,
  initEmptyBlockData as initEmptyGaleryV4Data,
} from "./GaleryV4Block/datas";
import GaleryV4Block from "./GaleryV4Block/GaleryV4Block";
import {
  initBlockData as initGaleryV5Data,
  initEmptyBlockData as initEmptyGaleryV5Data,
} from "./GaleryV5Block/datas";
import GaleryV5Block from "./GaleryV5Block/GaleryV5Block";
import {
  initBlockData as initGaleryV6Data,
  initEmptyBlockData as initEmptyGaleryV6Data,
} from "./GaleryV6Block/datas";
import GaleryV6Block from "./GaleryV6Block/GaleryV6Block";
import {
  initBlockData as initGaleryV7Data,
  initEmptyBlockData as initEmptyGaleryV7Data,
} from "./GaleryV7Block/datas";
import GaleryV7Block from "./GaleryV7Block/GaleryV7Block";
import {
  initBlockData as initGiftCardData,
  initEmptyBlockData as initEmptyGiftCardData,
} from "./GiftCardBlock/datas";
import GiftCardBlock from "./GiftCardBlock/GiftCardBlock";
import {
  initBlockData as initHeroData,
  initEmptyBlockData as initEmptyHeroData,
} from "./HeroBlock/datas";
import HeroBlock from "./HeroBlock/HeroBlock";
import {
  initBlockData as initIframeData,
  initEmptyBlockData as initEmptyIframeData,
} from "./IframeBlock/datas";
import IframeBlock from "./IframeBlock/IframeBlock";
import {
  initBlockData as initLatestData,
  initEmptyBlockData as initEmptyLatestData,
} from "./LatestBlock/datas";
import LatestBlock from "./LatestBlock/LatestBlock";
import {
  initBlockData as initLatestHeroData,
  initEmptyBlockData as initEmptyLatestHeroData,
} from "./LatestHeroBlock/datas";
import LatestHeroBlock from "./LatestHeroBlock/LatestHeroBlock";
import {
  initBlockData as initLatestListData,
  initEmptyBlockData as initEmptyLatestListData,
} from "./LatestListBlock/datas";
import LatestListBlock from "./LatestListBlock/LatestListBlock";
import {
  initBlockData as initManageBookingData,
  initEmptyBlockData as initEmptyManageBookingData,
} from "./ManageBookingBlock/datas";
import ManageBookingBlock from "./ManageBookingBlock/ManageBookingBlock";
import {
  initBlockData as initNewsData,
  initEmptyBlockData as initEmptyNewsData,
} from "./NewsBlock/datas";
import NewsBlock from "./NewsBlock/NewsBlock";
import {
  initBlockData as initNewsListData,
  initEmptyBlockData as initEmptyNewsListData,
} from "./NewsListBlock/datas";
import NewsListBlock from "./NewsListBlock/NewsListBlock";
import {
  initBlockData as initOperationsData,
  initEmptyBlockData as initEmptyOperationsData,
} from "./OperationsBlock/datas";
import OperationsBlock from "./OperationsBlock/OperationsBlock";
import {
  initBlockData as initPopularData,
  initEmptyBlockData as initEmptyPopularData,
} from "./PopularBlock/datas";
import PopularBlock from "./PopularBlock/PopularBlock";
import {
  initBlockData as initPromoData,
  initEmptyBlockData as initEmptyPromoData,
} from "./PromoBlock/datas";
import PromoBlock from "./PromoBlock/PromoBlock";
import {
  initBlockData as initPromosData,
  initEmptyBlockData as initEmptyPromosData,
} from "./PromosBlock/datas";
import PromosBlock from "./PromosBlock/PromosBlock";
import {
  initBlockData as initRegistrationData,
  initEmptyBlockData as initEmptyRegistrationData,
} from "./RegistrationBlock/datas";
import RegistrationBlock from "./RegistrationBlock/RegistrationBlock";
import {
  initBlockData as initStopsData,
  initEmptyBlockData as initEmptyStopsData,
} from "./StopsBlock/datas";
import StopsBlock from "./StopsBlock/StopsBlock";
import {
  initBlockData as initStoryListData,
  initEmptyBlockData as initEmptyStoryListData,
} from "./StoryListBlock/datas";
import StoryListBlock from "./StoryListBlock/StoryListBlock";
import {
  initBlockData as initSubscriptionData,
  initEmptyBlockData as initEmptySubscriptionData,
} from "./SubscriptionBlock/datas";
import SubscriptionBlock from "./SubscriptionBlock/SubscriptionBlock";
import {
  initBlockData as initTravelingData,
  initEmptyBlockData as initEmptyTravelingData,
} from "./TravelingBlock/datas";
import TravelingBlock from "./TravelingBlock/TravelingBlock";

const initBlockTemplate = {
  isShow: true,
};

const initBlockCommonSettings = {
  useWindowHeight: {
    component: "switcher",
    value: false,
  },
};

export const blocks = {
  subscription: {
    Component: SubscriptionBlock,
    preview: newsSvg,
    label: "subscription",
    categories: ["components"],
    initEmptyData: initEmptySubscriptionData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "subscription",
      data: {
        ...initSubscriptionData,
      },
    }),
  },
  promo: {
    Component: PromoBlock,
    preview: newsSvg,
    label: "promo",
    categories: ["components"],
    initEmptyData: initEmptyPromoData,
    block: merge(initBlockTemplate, {
      settings: {
        common: {
          ...defaultBlockSettings.common,
          blockType: {
            component: "blockType",
            value: commonBlocksOptions.blockType.options[6].value,
          },
        },
        specific: {},
      },
      name: "promo",
      data: {
        ...initPromoData,
      },
    }),
  },
  banner: {
    Component: BannerBlock,
    preview: contentSvg,
    label: "banner",
    categories: ["text", "pictures"],
    initEmptyData: initEmptyBannerData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {
          picture: {
            component: "selectOne",
            value: specificBlockOptions.banner.picture.options[2].value,
          },
          titlePosition: {
            component: "selectOne",
            value: specificBlockOptions.banner.titlePosition.options[0].value,
          },
          showMoreLink: {
            component: "switcher",
            value: false,
          },
          typeOfLink: {
            component: "selectOne",
            value: specificBlockOptions.banner.typeOfLink.options[0].value,
          },
        },
      },
      name: "banner",
      data: {
        ...initBannerData,
      },
    }),
  },
  content: {
    Component: ContentBlock,
    preview: contentSvg,
    label: "content",
    categories: ["text", "pictures"],
    initEmptyData: initEmptyContentData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: defaultBlockSettings.specific[CONTENT],
      },
      name: "content",
      data: {
        ...initContentData,
      },
    }),
  },
  // newContent: {
  //   Component: NewContentBlock,
  //   preview: contentSvg,
  //   label: "content new",
  //   categories: ["text", "pictures"],
  //   initEmptyData: initEmptyNewContentData,
  //   block: merge(initBlockTemplate, {
  //     settings: {
  //       common: defaultBlockSettings.common,
  //       specific: defaultBlockSettings.specific[NEW_CONTENT],
  //     },
  //     name: "newContent",
  //     data: {
  //       ...initNewContentData,
  //     },
  //   }),
  // },
  allDestinations: {
    Component: AllDestinationsBlock,
    preview: allDestinationsSvg,
    label: "all destinations",
    categories: ["components"],
    initEmptyData: initEmptyAllDestinationsData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "allDestinations",
      data: {
        ...initAllDestinationsData,
      },
    }),
  },
  allRoutes: {
    Component: AllRoutesBlock,
    preview: allRoutesSvg,
    label: "all routes",
    categories: ["components"],
    initEmptyData: initEmptyAllRoutesData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "allRoutes",
      data: {
        ...initAllRoutesData,
      },
    }),
  },
  latestHero: {
    Component: LatestHeroBlock,
    preview: latestHeroSvg,
    label: "latest hero",
    categories: ["banners"],
    initEmptyData: initEmptyLatestHeroData,
    block: merge(initBlockTemplate, {
      settings: {
        common: {
          ...defaultBlockSettings.common,
          blockType: {
            component: "blockType",
            value: commonBlocksOptions.blockType.options[6].value,
          },
        },
        specific: {
          contentType: {
            component: "selectOne",
            value: specificBlockOptions.latestHero.contentType.options[0].value,
          },
        },
      },
      name: "latestHero",
      data: {
        ...initLatestHeroData,
      },
    }),
  },
  hero: {
    Component: HeroBlock,
    preview: heroSvg,
    label: "hero",
    categories: ["banners"],
    initEmptyData: initEmptyHeroData,
    block: merge(initBlockTemplate, {
      settings: {
        common: {
          ...defaultBlockSettings.common,
          blockType: {
            component: "blockType",
            value: commonBlocksOptions.blockType.options[6].value,
          },
        },
        specific: {
          titleType: {
            component: "selectOne",
            value: specificBlockOptions.hero.titleType.options[0].value,
          },
          subTitleType: {
            component: "selectOne",
            value: specificBlockOptions.hero.subTitleType.options[0].value,
          },
          showSearch: {
            component: "switcher",
            value: true,
          },
          backgroundOption: {
            component: "selectOne",
            value: specificBlockOptions.hero.backgroundOption.options[0].value,
          },
          defaultRoute: {
            component: "defaultRoute",
            value: {
              from: "",
              to: "",
            },
          },
        },
      },
      name: "hero",
      data: {
        ...initHeroData,
      },
    }),
  },
  galeryV1: {
    Component: GaleryV1Block,
    preview: gallerySvg, // TODO: add correct preview
    label: "galery v1",
    categories: ["galeries"],
    initEmptyData: initEmptyGaleryV1Data,
    block: merge(initBlockTemplate, {
      settings: {
        common: {
          ...defaultBlockSettings.common,
          blockType: {
            component: "blockType",
            value: commonBlocksOptions.blockType.options[6].value,
          },
        },
        specific: {},
      },
      name: "galeryV1",
      data: {
        ...initGaleryV1Data,
      },
    }),
  },
  galeryV2: {
    Component: GaleryV2Block,
    preview: destinationsSvg, // TODO: add correct preview
    label: "galery v2",
    categories: ["galeries"],
    initEmptyData: initEmptyGaleryV2Data,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "galeryV2",
      data: {
        ...initGaleryV2Data,
      },
    }),
  },
  galeryV3: {
    Component: GaleryV3Block,
    preview: galleryAndTextSvg, // TODO: add correct preview
    label: "gallery",
    categories: ["galeries"],
    initEmptyData: initEmptyGaleryV3Data,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "galeryV3",
      data: {
        ...initGaleryV3Data,
      },
    }),
  },
  galeryV4: {
    Component: GaleryV4Block,
    preview: testimonialsSvg, // TODO: add correct preview
    label: "Reviews gallery",
    categories: ["galeries"],
    initEmptyData: initEmptyGaleryV4Data,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "galeryV4",
      data: {
        ...initGaleryV4Data,
      },
    }),
  },
  galeryV5: {
    Component: GaleryV5Block,
    preview: promoSvg, // TODO: add correct preview
    label: "galery v5",
    categories: ["galeries"],
    initEmptyData: initEmptyGaleryV5Data,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "galeryV5",
      data: {
        ...initGaleryV5Data,
      },
    }),
  },
  galeryV6: {
    Component: GaleryV6Block,
    preview: galleryAndTextSvg,
    label: "Events gallery",
    categories: ["galeries"],
    initEmptyData: initEmptyGaleryV6Data,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "galeryV6",
      data: {
        ...initGaleryV6Data,
      },
    }),
  },
  galeryV7: {
    Component: GaleryV7Block,
    preview: gallerySvg,
    label: "Simple gallery",
    categories: ["galeries"],
    initEmptyData: initEmptyGaleryV7Data,
    block: merge(initBlockTemplate, {
      settings: {
        common: {
          ...defaultBlockSettings.common,
          blockType: {
            component: "blockType",
            value: commonBlocksOptions.blockType.options[6].value,
          },
        },
        specific: {},
      },
      name: "galeryV7",
      data: {
        ...initGaleryV7Data,
      },
    }),
  },
  traveling: {
    Component: TravelingBlock,
    preview: whyLuxSvg, // TODO: add correct preview
    label: "traveling",
    categories: ["components"],
    initEmptyData: initEmptyTravelingData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "traveling",
      data: {
        ...initTravelingData,
      },
    }),
  },
  operations: {
    Component: OperationsBlock,
    preview: allRoutesSvg, // TODO: add correct preview
    label: "operations",
    categories: ["components"],
    initEmptyData: initEmptyOperationsData,
    block: merge(initBlockTemplate, {
      settings: {
        common: {
          ...defaultBlockSettings.common,
          blockType: {
            component: "blockType",
            value: commonBlocksOptions.blockType.options[1].value,
          },
        },
        specific: {},
      },
      name: "operations",
      data: {
        ...initOperationsData,
      },
    }),
  },
  news: {
    Component: NewsBlock,
    preview: newsSvg, // TODO: add correct preview
    label: "news",
    isHidden: true,
    categories: ["text"],
    initEmptyData: initEmptyNewsData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "news",
      data: {
        ...initNewsData,
      },
    }),
  },
  latest: {
    Component: LatestBlock,
    preview: latestSvg, // TODO: add correct preview
    label: "latest",
    categories: ["components"],
    initEmptyData: initEmptyLatestData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {
          contentType: {
            component: "selectOne",
            value: specificBlockOptions.latest.contentType.options[0].value,
          },
        },
      },
      name: "latest",
      data: {
        ...initLatestData,
      },
    }),
  },
  popular: {
    Component: PopularBlock,
    preview: popularSvg, // TODO: add correct preview
    label: "popular",
    categories: ["components"],
    initEmptyData: initEmptyPopularData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "popular",
      data: {
        ...initPopularData,
      },
    }),
  },
  stops: {
    Component: StopsBlock,
    preview: stopsSvg,
    label: "stops",
    categories: ["galeries"],
    initEmptyData: initEmptyStopsData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "stops",
      data: {
        ...initStopsData,
      },
    }),
  },
  contacts: {
    Component: ContactsBlock,
    preview: contactsSvg,
    label: "contacts",
    categories: ["components"],
    initEmptyData: initEmptyContactsData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "contacts",
      data: {
        ...initContactsData,
      },
    }),
  },
  giftCard: {
    Component: GiftCardBlock,
    preview: contactsSvg,
    label: "gift card",
    categories: ["components"],
    initEmptyData: initEmptyGiftCardData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "giftCard",
      data: {
        ...initGiftCardData,
      },
    }),
  },
  promos: {
    Component: PromosBlock,
    preview: contactsSvg,
    label: "promos",
    categories: ["components"],
    initEmptyData: initEmptyPromosData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {
          showActive: {
            component: "switcher",
            value: true,
          },
          showPassed: {
            component: "switcher",
            value: true,
          },
        },
      },
      name: "promos",
      data: {
        ...initPromosData,
      },
    }),
  },
  registration: {
    Component: RegistrationBlock,
    preview: contactsSvg,
    label: "registration",
    categories: ["components"],
    initEmptyData: initEmptyRegistrationData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "registration",
      data: {
        ...initRegistrationData,
      },
    }),
  },
  newsList: {
    Component: NewsListBlock,
    preview: contactsSvg,
    label: "news list",
    categories: ["components"],
    initEmptyData: initEmptyNewsListData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "newsList",
      data: {
        ...initNewsListData,
      },
    }),
  },
  storyList: {
    Component: StoryListBlock,
    preview: contactsSvg,
    label: "story list",
    categories: ["components"],
    initEmptyData: initEmptyStoryListData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "storyList",
      data: {
        ...initStoryListData,
      },
    }),
  },
  manageBooking: {
    Component: ManageBookingBlock,
    preview: contactsSvg,
    label: "manage booking",
    categories: ["components"],
    initEmptyData: initEmptyManageBookingData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "manageBooking",
      data: {
        ...initManageBookingData,
      },
    }),
  },
  iframe: {
    Component: IframeBlock,
    preview: contactsSvg,
    label: "iframe",
    categories: ["components"],
    initEmptyData: initEmptyIframeData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {
          iframeString: {
            component: "iframe",
            value: "",
          },
        },
      },
      name: "iframe",
      data: {
        ...initIframeData,
      },
    }),
  },
  button: {
    Component: ButtonBlock,
    preview: contactsSvg,
    label: "button",
    categories: ["components"],
    initEmptyData: initEmptyButtonData,
    block: merge(initBlockTemplate, {
      settings: {
        common: {
          ...defaultBlockSettings.common,
          blockType: {
            component: "blockType",
            value: commonBlocksOptions.blockType.options[6].value,
          },
        },
        specific: {
          buttonStyle: {
            component: "selectOne",
            value: specificBlockOptions.button.buttonStyle.options[0].value,
          },
          position: {
            component: "selectOne",
            value: specificBlockOptions.button.position.options[0].value,
          },
        },
      },
      name: "button",
      data: {
        ...initButtonData,
      },
    }),
  },
  advBanner: {
    Component: AdvBannerBlock,
    preview: contentSvg,
    label: "advBanner",
    categories: ["components"],
    initEmptyData: initEmptyAdvBannerData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {},
      },
      name: "advBanner",
      data: {
        ...initAdvBannerData,
      },
    }),
  },
  latestList: {
    Component: LatestListBlock,
    preview: newsSvg,
    label: "latestList",
    categories: ["components"],
    initEmptyData: initEmptyLatestListData,
    block: merge(initBlockTemplate, {
      settings: {
        common: defaultBlockSettings.common,
        specific: {
          contentType: {
            component: "selectOne",
            value: specificBlockOptions.latestList.contentType.options[0].value,
          },
          itemsAmount: {
            component: "selectOne",
            value: specificBlockOptions.latestList.itemsAmount.options[0].value,
          },
          showPicture: {
            component: "switcher",
            value: false,
          },
          showDescription: {
            component: "switcher",
            value: false,
          },
          showDate: {
            component: "switcher",
            value: false,
          },
          showLoadMore: {
            component: "switcher",
            value: false,
          },
        },
      },
      name: "latestList",
      data: {
        ...initLatestListData,
      },
    }),
  },
};

export const getDefaultBlock = (name) => {
  if (!blocks[name]) {
    console.error(`getBlockTemplate(): Block '${name}' not found`);
  }
  return blocks[name].block;
  // initEmptyData: defaultData[name] || {},
  // Component: blocks[name].Component || (() => null),
};

export const getBlockTemplate = (name) => {
  if (!blocks[name]) {
    console.error(`getBlockTemplate(): Block '${name}' not found`);
  }

  return blocks[name] || {};
};

export const createBlockByName = (name, settings = null) => {
  if (!blocks[name]) {
    console.error(`getBlockTemplate(): Block '${name}' not found`);
  }

  const block = { ...blocks[name].block };

  if (settings) {
    block.settings = merge(block.settings, settings);
  }

  return block;
  // initEmptyData: defaultData[name] || {},
  // Component: blocks[name].Component || (() => null),
};

export default getBlockTemplate;
